import { UPDATE_SELECTED_NODE_HIERARCHY } from "../actionTypes";

export const updateSelectedNodeHierarchy = (payload) => {
  return {
    type: UPDATE_SELECTED_NODE_HIERARCHY,
    payload,
  };
};
